import React, { useState } from 'react';

const VideoForm = ({ onVideoSubmit, isLoading }) => {
  const [videoUrl, setVideoUrl] = useState('');
  const [urlError, setUrlError] = useState('');

  const validateYoutubeUrl = (url) => {
    // Basic YouTube URL validation
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubeRegex.test(url);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUrlError('');
    
    if (!videoUrl.trim()) {
      setUrlError('Please enter a YouTube URL');
      return;
    }
    
    if (!validateYoutubeUrl(videoUrl)) {
      setUrlError('Please enter a valid YouTube URL');
      return;
    }
    
    onVideoSubmit(videoUrl);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <h2 className="text-lg font-semibold mb-3">Enter YouTube URL</h2>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
        <div className="flex-grow">
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => {
              setVideoUrl(e.target.value);
              if (urlError) setUrlError('');
            }}
            placeholder="https://youtube.com/watch?v=..."
            className={`w-full p-2 border ${urlError ? 'border-red-500' : 'border-gray-300'} rounded focus:ring-2 focus:ring-indigo-300 focus:outline-none`}
            disabled={isLoading}
          />
          {urlError && <p className="text-red-500 text-sm mt-1">{urlError}</p>}
        </div>
        <button 
          type="submit" 
          className={`${
            isLoading 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-indigo-600 hover:bg-indigo-700'
          } text-white py-2 px-4 rounded transition duration-200 whitespace-nowrap`}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="flex items-center">
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Loading...
            </span>
          ) : 'Load Video'}
        </button>
      </form>
      <p className="text-xs text-gray-500 mt-2">
        Enter a full YouTube video URL (e.g., https://www.youtube.com/watch?v=dQw4w9WgXcQ)
      </p>
    </div>
  );
};

export default VideoForm;
